/**
 * Matriz CSS que lleva el rectángulo (0,0)–(w,h) a un cuadrilátero (arriba izq., arriba
 * der., abajo der., abajo izq.): la transformación proyectiva del cuadrado unidad
 * (Heckbert, 1989), escalada al tamaño del bloque. Así el chat de Yvyra (HTML) se apoya
 * exacto sobre la pantalla del celular 3D.
 */
export function quadMatrix(w: number, h: number, p: readonly number[]) {
  const [x0, y0, x1, y1, x2, y2, x3, y3] = p;
  const dx1 = x1 - x2;
  const dx2 = x3 - x2;
  const dx3 = x0 - x1 + x2 - x3;
  const dy1 = y1 - y2;
  const dy2 = y3 - y2;
  const dy3 = y0 - y1 + y2 - y3;
  const det = dx1 * dy2 - dx2 * dy1;
  const g = det === 0 ? 0 : (dx3 * dy2 - dx2 * dy3) / det;
  const k = det === 0 ? 0 : (dx1 * dy3 - dx3 * dy1) / det;
  const a = x1 - x0 + g * x1;
  const b = x3 - x0 + k * x3;
  const d = y1 - y0 + g * y1;
  const e = y3 - y0 + k * y3;
  const m = [a / w, d / w, 0, g / w, b / h, e / h, 0, k / h, 0, 0, 1, 0, x0, y0, 0, 1];
  // Precisión relativa, no decimales fijos: g/w y k/h son del orden de 1e-4.
  return `matrix3d(${m.map((v) => +v.toPrecision(9)).join(",")})`;
}
